import request from '../utils/request.js'

export default {
	getList(params) {
		return request.post(`notice/lists`, params).then(res => res.data);
	},
	add(params) {
		return request.post(`notice/add`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`notice/add`, params).then(res => res.data);
	},
	details(params) {
		return request.post(`notice/details`, params).then(res => res.data);
	},
	delete(params) {
		return request.post(`notice/del`, params).then(res => res.data);
	},
	// 获取系统通知（工作台用）
	getSystemNotices(params) {
		return request.post(`system_notice/lists`, params).then(res => res.data);
	},
	// 标记通知为已读
	markRead(params) {
		return request.post(`system_notice/markRead`, params).then(res => res.data);
	},
	// 标记全部已读
	markAllRead(params) {
		return request.post(`system_notice/markAllRead`, params).then(res => res.data);
	}
}


// WEBPACK FOOTER //
// ./src/api/notice.js